import { Button } from 'antd';
import { ReactElement, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  id: number;
}

const DetailButton = ({ id }: Props): ReactElement => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    void navigate(`/advisors/${String(id)}`);
  }, [id, navigate]);
  return (
    <Button size='small' onClick={handleClick}>
      詳細
    </Button>
  );
};

export default DetailButton;
